import { render, staticRenderFns } from "./messageviewhtml.vue?vue&type=template&id=0bef2bee&"
import script from "./messageviewhtml.vue?vue&type=script&lang=ts&"
export * from "./messageviewhtml.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports